import { render, staticRenderFns } from "./angle.vue?vue&type=template&id=5787c792&scoped=true&"
import script from "./angle.vue?vue&type=script&lang=js&"
export * from "./angle.vue?vue&type=script&lang=js&"
import style0 from "./angle.vue?vue&type=style&index=0&id=5787c792&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5787c792",
  null
  
)

export default component.exports